import { useAuth } from '@skyslope/auth-react';

export const useIsAllowedToModifySensitiveInfo = (): boolean => {
  const { userContext } = useAuth();
  return !userContext?.oktaGroups?.includes('/prime/users') ?? false;
};
